<template>
  <div style="border: solid 0px purple">
    <div class="container">
      <div class="row justify-content-md-center">
        <h1 class="display-3 my-5">{{ pageHeading }}</h1>
        <div class="col col-md-6" style="border: solid 0px red">
          <!-- <h2>{{ bNumber }}, {{ dNumber }}, {{ hNumber }}</h2> -->
          <div class="mb-5">
            <label for="exampleFormControlInput1" class="form-label"
              >Binary</label
            >
            <input
              class="form-control form-control-lg text-end"
              v-model="bNumber"
              @keyup="bNumberChanged($event.target.value)"
              type="text"
            />
          </div>
          <div class="mb-5">
            <label for="exampleFormControlInput1" class="form-label"
              >Decimal</label
            >
            <input
              class="form-control form-control-lg text-end"
              v-model="dNumber"
              @keyup="dNumberChanged($event.target.value)"
              type="text"
            />
          </div>
          <div class="mb-5">
            <label for="exampleFormControlInput1" class="form-label"
              >Hexadecimal</label
            >
            <input
              class="form-control form-control-lg text-end"
              v-model="hNumber"
              @keyup="hNumberChanged($event.target.value)"
              type="text"
            />
          </div>
        </div>
        <br />
        <a href="https://www.imagenation.com.hk" class="in-link">
          <span style="color: #ffce2b">&lt;</span>image<span
            style="color: #ffce2b"
            >/</span
          >nation<span style="color: #ffce2b">&gt;</span>
        </a>
        <br /><br />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseConvertor",
  data() {
    return {
      number: 0,
      bNumber: "",
      dNumber: "",
      hNumber: "",
    };
  },
  props: {
    pageHeading: String,
  },
  methods: {
    bNumberChanged: function (value) {
      //console.log("nNumberOnChange ... " + value);
      if (!isNaN(value) && value != "") {
        this.dNumber = parseInt(value, 2);
        this.hNumber = this.dNumber.toString(16).toUpperCase();
        //this.hNumber = base_convert(value, 2, 16);
      } else {
        this.dNumber = "";
        this.hNumber = "";
      }
    }, // end of bNumberChanged
    dNumberChanged: function (value) {
      //console.log("dNumberOnChange ... " + value);
      if (!isNaN(value) && value != "") {
        this.bNumber = parseInt(value).toString(2);
        this.hNumber = parseInt(value).toString(16).toUpperCase();
        //this.hNumber = base_convert(value, 2, 16);
      } else {
        this.bNumber = "";
        this.hNumber = "";
      }
    }, // end of dNumberChanged
    hNumberChanged: function (value) {
      //console.log("hNumberOnChange ... " + value);
      if (value != "") {
        this.hNumber = this.hNumber.toUpperCase();
        this.bNumber = parseInt(value, 16).toString(2);
        this.dNumber = parseInt(value, 16).toString(10);
      } else {
        this.bNumber = "";
        this.dNumber = "";
      }
    }, // end of hNumberChanged
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.in-link {
  text-decoration: none;
  color: black;
}
</style>
